
// src/pages/MetricsVisualisationsPage.js
import React from 'react';
import MetricsVisualisations from '../components/MetricsVisualisations';

const MetricsVisualisationsPage = ({
  selectedCompany,
  selectedQuarter,      // optional
  historicalSeries,
  visualQuarters,
  setVisualQuarters
}) => {
  return (
    <div className="w-full min-w-0">
      {selectedCompany ? (
        <MetricsVisualisations
          selectedCompany={selectedCompany}
          historicalSeries={historicalSeries}
          visualQuarters={visualQuarters}
          setVisualQuarters={setVisualQuarters}
          selectedQuarter={selectedQuarter} // optional (safe to keep)
        />
      ) : (
        <p className="text-gray-600">
          Please select a company to view metrics.
        </p>
      )}
    </div>
  );
};

export default MetricsVisualisationsPage;




